/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type voice_ParseVoiceRequest = {
    /**
     * ChildIDs is an optional list of pre-filtered child IDs to consider.
     * If provided, only these children will be considered for name resolution.
     * Max 500 IDs, each max 255 characters.
     */
    child_ids?: Array<string>;
    /**
     * ChildcareID scopes the portfolio domain lookup. Required when
     * target is "observation"; ignored otherwise.
     */
    childcare_id?: string;
    /**
     * Target selects the extraction shape. Absent means "activity".
     * One of: "activity", "observation".
     */
    target?: voice_ParseVoiceRequest.target;
    /**
     * Transcription is the voice transcription text to parse.
     * Required. The tag carries the OBSERVATION cap; the activity path re-imposes
     * its own 500-character cap in the handler so its 400 response is unchanged.
     */
    transcription: string;
};
export namespace voice_ParseVoiceRequest {
    /**
     * Target selects the extraction shape. Absent means "activity".
     * One of: "activity", "observation".
     */
    export enum target {
        ACTIVITY = 'activity',
        OBSERVATION = 'observation',
    }
}

